

import Accordion from '../classes/Accordion';

export default class AboutServices  {
	constructor(elm) {
        this.elm = elm;

		this.init();
	}

	init() {

        const accordions = this.elm.querySelectorAll('[data-accordion]');

		accordions.forEach(accordion => {
			new Accordion(accordion);
		});

	}

}
